import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-4 text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiDatePicker = _resolveComponent("UiDatePicker")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiDatePicker, {
      modelValue: $setup.dateRange,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateRange) = $event)),
      range: "",
      multiCalendars: ""
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_UiMultiselect, {
      name: "filters_type",
      modelValue: $setup.timelineStore.callType,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.timelineStore.callType) = $event)),
      options: $setup.callTypeFilterOptions,
      placeholder: $setup.t('contact.filters.allCallTypes'),
      class: "[&_.multiselect]:!h-[36px]",
      "can-clear": ""
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createVNode(_component_UiMultiselect, {
      name: "filters_sentiment",
      modelValue: $setup.timelineStore.sentiment,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.timelineStore.sentiment) = $event)),
      options: $setup.sentimentFilterOptions,
      placeholder: $setup.t('contact.filters.allSentiments'),
      class: "[&_.multiselect]:!h-[36px]",
      "can-clear": ""
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
  ]))
}